let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5O6ot")).then(() => parcelRequire('dbL6c'));